import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import withModal from "../withModal";
import MaterialModal from "../MaterialModal";

type Props = {
    isOpen: boolean;
    modalProps?: {
        closeModal: (value?: boolean) => void;
    };
};

const SimpleToLegacyModal: React.FC<Props> = ({ isOpen, modalProps }: Props) => {
    const dispatch = useDispatch();

    const handleContinue = () => {
        if (modalProps && modalProps.closeModal) {
            modalProps.closeModal(true);
        }
        dispatch(hideModal("SIMPLE_TO_LEGACY"));
    };

    const handleCancel = () => {
        if (modalProps && modalProps.closeModal) {
            modalProps.closeModal(false);
        }
        dispatch(hideModal("SIMPLE_TO_LEGACY"));
    };

    return (
        <MaterialModal
            isOpen={isOpen}
            title="Confirm Action"
            onClose={handleCancel} // Ensure onClose handles the cancel action
            id="simple-to-legacy-modal"
            primaryButtonText="Continue"
            onPrimaryButtonRequest={handleContinue}
            cancelButtonText="Cancel"
        >
            <p>If you make this change, you will not be able to go back to the Simple Flow UI. Do you want to continue?</p>
        </MaterialModal>
    );
};

export default withModal(SimpleToLegacyModal, "SIMPLE_TO_LEGACY");